import React, { Component } from 'react';
import { Grid, Col, Row, Button, FormControl } from 'react-bootstrap';

import Datetime from 'react-datetime';
import moment from 'moment';
import Select from 'react-select';
import { ADD_SELECTED_PRODUCTS, CLEAR_SELECTED_PRODUCTS } from 'actions/actionTypes';
import {
  prepareSelectOptionsList,
  filterFocusAreaOptions,
  filterFocusAreaSelectedOptions,
} from 'util/Utils';
import config from '../../../config';
import { getAllowedAgeGroups } from '../../shared/sharedMethods';
import { productStatusLabels , processingStatusFilterCalculate } from './helper/adminProduct.const';

var listingStatusOptions = [
  { value: 'Listings', label: 'Listings' },
  { value: 'Prelistings', label: 'Prelisting' },
  { value: 'PrePrelistings', label: 'Original products' },
  { value: 'Troubleshooting', label: 'Troubleshooting' },
  { value: 'FinalizedListings', label: 'Finalized listings' },
  { value: 'ListingsPostedDirectly', label: 'Posted directly' },
];
var productLocationStatusOptions = [
  { value: 'NotChecked', label: 'Not checked' },
  { value: 'NotScanned', label: 'Not scanned' },
  { value: 'Missing', label: 'Missing' },
  { value: 'Confirmed', label: 'Confirmed' },
];
var palletStatusOptions = [
  { value: 'Incoming', label: 'Incoming' },
  { value: 'In Progress', label: 'In Progress' },
  { value: 'Checked', label: 'Checked' },
];
var statusOptions = [
  { value: 'Active', label: 'Active' },
  { value: 'Inactive', label: 'Inactive' },
];
export default class AdminProductSearchBox extends Component {
  static get contextTypes() {
    return {
      router: React.PropTypes.object.isRequired,
    };
  }

  constructor(props, context) {
    super(props, context);
    var ageGroup = _.isUndefined(this.props.location.query.ageGroup)
      ? 'all'
      : this.props.location.query.ageGroup;
    var selectedFocusAreas = _.isUndefined(this.props.location.query.focus)
      ? []
      : _.map(this.props.location.query.focus.split(','), function (tag) {
          return { value: tag, label: tag };
        });
    var selectedMarkets = _.isUndefined(this.props.location.query.Markets)
      ? []
      : _.map(this.props.location.query.Markets.split(','), function (item) {
          var location = _.find(config.warehouseData, function (o) {
            return o.MarketName == item;
          });
          if (location) {
            return { value: item, label: location.MarketName };
          }
        });
    selectedMarkets = _.difference(selectedMarkets, config.allSubMarkets);

    var filterOptions = {
      focus:
        ageGroup == 'all'
          ? selectedFocusAreas
          : filterFocusAreaSelectedOptions(
              this.props.focusAreas.data,
              ageGroupMap,
              selectedFocusAreas
            ),
      ageGroup: ageGroup,
      perPage: _.isUndefined(this.props.location.query.perPage)
        ? config.table.numberPerPage
        : this.props.location.query.perPage,
      SellerID: _.isUndefined(this.props.location.query.SellerID)
        ? 'all'
        : this.props.location.query.SellerID,
      CreatedBy: _.isUndefined(this.props.location.query.CreatedBy)
        ? ''
        : this.props.location.query.CreatedBy,
      fromCreateTimeDisplay: _.isUndefined(this.props.location.query.from)
        ? ''
        : moment(this.props.location.query.from),
      toCreateTimeDisplay: _.isUndefined(this.props.location.query.to)
        ? ''
        : moment(this.props.location.query.to),
      fromSoldTimeDisplay: _.isUndefined(this.props.location.query.fromSoldAt)
        ? ''
        : moment(this.props.location.query.fromSoldAt),
      toSoldTimeDisplay: _.isUndefined(this.props.location.query.toSoldAt)
        ? ''
        : moment(this.props.location.query.toSoldAt),
      inventory: _.isUndefined(this.props.location.query.inventory)
        ? []
        : _.isArray(this.props.location.query.inventory)
        ? _.map(this.props.location.query.inventory, function (value) {
            return _.find(config.inventoryOwnershipMap, { value: value });
          })
        : [_.find(config.inventoryOwnershipMap, { value: this.props.location.query.inventory })],
      maxPrice: _.isUndefined(this.props.location.query.maxPrice)
        ? ''
        : this.props.location.query.maxPrice,
      minPrice: _.isUndefined(this.props.location.query.minPrice)
        ? ''
        : this.props.location.query.minPrice,
      zip: _.isUndefined(this.props.location.query.zip) ? '' : this.props.location.query.zip,
      searchText: _.isUndefined(this.props.location.query.searchText)
        ? ''
        : this.props.location.query.searchText,
      searchFields: _.isUndefined(this.props.location.query.searchFields)
        ? 'Status'
        : this.props.location.query.searchFields,

      PalletID: _.get(this.props.location.query, 'PalletID', ''),
      InventoryProjectID: _.get(this.props.location.query, 'InventoryProjectID', ''),
      text: _.get(this.props, 'location.query.text', ''),
      productLocationStatuses: _.isUndefined(this.props.location.query.productLocationStatuses)
        ? []
        : _.isArray(this.props.location.query.productLocationStatuses)
        ? _.map(this.props.location.query.productLocationStatuses, function (value) {
            return _.find(productLocationStatusOptions, { value: value });
          })
        : [
            _.find(productLocationStatusOptions, {
              value: this.props.location.query.productLocationStatuses,
            }),
          ],
      listingStatuses: _.isUndefined(this.props.location.query.listingStatuses)
        ? []
        : _.isArray(this.props.location.query.listingStatuses)
        ? _.map(this.props.location.query.listingStatuses, function (value) {
            return _.find(listingStatusOptions, { value: value });
          })
        : [_.find(listingStatusOptions, { value: this.props.location.query.listingStatuses })],
      disposition: _.isUndefined(this.props.location.query.disposition)
        ? []
        : _.isArray(this.props.location.query.disposition)
        ? _.map(this.props.location.query.disposition, function (value) {
            return _.find(config.dispositionOptions, { value: value });
          })
        : [_.find(config.dispositionOptions, { value: this.props.location.query.disposition })],
      palletStatuses: _.isUndefined(this.props.location.query.palletStatuses)
        ? []
        : _.isArray(this.props.location.query.palletStatuses)
        ? _.map(this.props.location.query.palletStatuses, function (value) {
            return _.find(palletStatusOptions, { value: value });
          })
        : [_.find(palletStatusOptions, { value: this.props.location.query.palletStatuses })],
      Statuses: _.isUndefined(this.props.location.query.Statuses)
        ? []
        : _.isArray(this.props.location.query.Statuses)
        ? _.map(this.props.location.query.Statuses, function (value) {
            return _.find(statusOptions, { value: value });
          })
        : [_.find(statusOptions, { value: this.props.location.query.Statuses })],
      Markets: selectedMarkets,
      ServiceID: _.get(this.props.location.query, 'ServiceID', ''),
      Deleted: _.isUndefined(this.props.location.query.Deleted)
        ? null
        : this.props.location.query.Deleted,
      fromQuantity: _.isUndefined(this.props.location.query.fromQuantity)
        ? ''
        : this.props.location.query.fromQuantity,
      toQuantity: _.isUndefined(this.props.location.query.toQuantity)
        ? ''
        : this.props.location.query.toQuantity,
      ShopifyProductID: _.isUndefined(this.props.location.query.ShopifyProductID)
        ? ''
        : this.props.location.query.ShopifyProductID,
      recordIDs: _.isUndefined(this.props.location.query.recordIDs)
        ? []
        : _.isArray(this.props.location.query.recordIDs)
        ? _.get(this.props.location.query, 'recordIDs', [])
        : [_.get(this.props.location.query, 'recordIDs')],
      productIDs: _.isUndefined(this.props.location.query.productIDs)
        ? []
        : _.isArray(this.props.location.query.productIDs)
        ? _.get(this.props.location.query, 'productIDs', [])
        : [_.get(this.props.location.query, 'productIDs')],
      processingStatus:processingStatusFilterCalculate (this.props.location.query.processingStatus),
    };

    var ageGroupMap = ageGroup == 'all' ? [] : [ageGroup];
    this.state = {
      focusAreasOptionsList: filterFocusAreaOptions(this.props.focusAreas.data, ageGroupMap),
      filterOptions: filterOptions,
    };
    this.allSellersOptionsList = prepareSelectOptionsList(this.props.allSellersList.data, {
      label: 'DisplayName',
      value: '_id',
    });
    this.getUsersByRoles();
    this.allCreatedByOptionsList = [];

    this.onCreateTimeChange = this.onCreateTimeChange.bind(this);
    this.allSellersOptionsList.unshift({ label: 'All', value: 'all' });
  }

  componentWillReceiveProps(nextProps) {
    if (_.size(nextProps.focusAreas.data) !== _.size(this.props.focusAreas.data)) {
      var selectedFocusAreas = _.isUndefined(this.props.location.query.focus)
        ? []
        : _.map(this.props.location.query.focus.split(','), function (tag) {
            return { value: tag, label: tag };
          });
      var ageGroupMap =
        this.state.filterOptions.ageGroup == 'all' ? [] : [this.state.filterOptions.ageGroup];

      var updateOptions = {
        ...this.state.filterOptions,
        focus:
          this.state.filterOptions.ageGroup == 'all'
            ? selectedFocusAreas
            : filterFocusAreaSelectedOptions(
                nextProps.focusAreas.data,
                ageGroupMap,
                selectedFocusAreas
              ),
      };
      console.log('update', updateOptions, selectedFocusAreas);
      this.setState({
        filterOptions: updateOptions,
        focusAreasOptionsList: filterFocusAreaOptions(nextProps.focusAreas.data, ageGroupMap),
      });
    }

    if (_.size(nextProps.allSellersList.data) !== _.size(this.props.allSellersList.data)) {
      this.allSellersOptionsList = prepareSelectOptionsList(nextProps.allSellersList.data, {
        label: 'DisplayName',
        value: '_id',
      });
    }
  }
  getUsersByRoles() {
    var self = this;
    this.props
      .makeRequest(
        {
          all: true,
          Roles: ['Wingmom', 'Ops Manager', 'Product Manager', 'Administrator'],
        },
        {
          endpoint: '/users',
          not_display_success_message: true,
        }
      )
      .then((res) => {
        this.allCreatedByOptionsList = prepareSelectOptionsList(_.get(res.data, 'data', []), {
          label: (item) => {
            return item.firstName + (item.lastName ? ' ' + item.lastName : '');
          },
          value: '_id',
        });
        //  this.allCreatedByOptionsList.unshift({label: 'All', value: 'all'});

        self.setState({});
      });
  }
  onChangePerPageNumber(option) {
    this.setState({ filterOptions: { ...this.state.filterOptions, perPage: option.value } });
  }

  getSearchParams(filtersChanged = {}) {
    var filterOptions = { ...this.state.filterOptions, ...filtersChanged };
    var queryParams = {};

    queryParams.perPage = filterOptions.perPage;

    if (!_.isUndefined(filterOptions.ShopifyProductID) && filterOptions.ShopifyProductID !== '') {
      queryParams.ShopifyProductID = filterOptions.ShopifyProductID;
    }
    if (_.size(filterOptions.focus) > 0) {
      queryParams.focus = _.map(filterOptions.focus, 'value').join(',');
    }
    console.log('filterOptions', filterOptions);
    if (_.size(filterOptions.recordIDs) > 0) {
      queryParams.recordIDs = filterOptions.recordIDs;
      queryParams.all = true;
    }
    if (_.size(filterOptions.productIDs) > 0) {
      queryParams.productIDs = filterOptions.productIDs;

      queryParams.all = true;
    }

    if (_.size(filterOptions.Markets) > 0) {
      var Markets = [];

      _.forEach(filterOptions.Markets, (item) => {
        console.log('item', item);
        var SubMarkets = _.get(config.warehouseData[item.value], 'SubMarkets', []);
        console.log('SubMarkets', SubMarkets);
        if (SubMarkets.length) {
          Markets.push(item.value);
          Markets = _.concat(Markets, SubMarkets);
        } else {
          Markets.push(item.value);
        }
      });

      queryParams.Markets = Markets.join(',');
    }
    if (filterOptions.SellerID !== 'all') {
      queryParams.SellerID = filterOptions.SellerID;
    }
    if (filterOptions.CreatedBy) {
      queryParams.CreatedBy = filterOptions.CreatedBy;
    }
    if (filterOptions.ServiceID !== '') {
      queryParams.ServiceID = queryParams.PickupID = filterOptions.ServiceID;
    }
    if (filterOptions.fromQuantity !== '') {
      queryParams.fromQuantity = filterOptions.fromQuantity;
    }
    if (filterOptions.toQuantity !== '') {
      queryParams.toQuantity = filterOptions.toQuantity;
    }
    if (filterOptions.Deleted) {
      queryParams.Deleted = filterOptions.Deleted;
    }
    if (filterOptions.ageGroup !== 'all') {
      queryParams.ageGroup = filterOptions.ageGroup;
    }
    if (filterOptions.fromCreateTimeDisplay !== '') {
      queryParams.from = filterOptions.fromCreateTimeDisplay.toISOString();
    }
    if (filterOptions.toCreateTimeDisplay !== '') {
      queryParams.to = filterOptions.toCreateTimeDisplay.toISOString();
    }
    if (filterOptions.fromSoldTimeDisplay !== '') {
      queryParams.fromSoldAt = filterOptions.fromSoldTimeDisplay.toISOString();
    }
    if (filterOptions.toSoldTimeDisplay !== '') {
      queryParams.toSoldAt = filterOptions.toSoldTimeDisplay.toISOString();
    }
    if (filterOptions.maxPrice !== '') {
      queryParams.maxPrice = filterOptions.maxPrice;
    }

    if (filterOptions.minPrice !== '') {
      queryParams.minPrice = filterOptions.minPrice;
    }
    if (filterOptions.text !== '') {
      queryParams.text = filterOptions.text;
    }
    if (filterOptions.searchText !== '') {
      queryParams.searchText = filterOptions.searchText;
      if (filterOptions.searchFields == 'wa') {
        queryParams.customSearchText = queryParams.searchText;
        delete queryParams.searchText;
        queryParams.customSearchFields = ['InventoryProjectRecordWarehouseLocation.LocationArea'];
        queryParams.searchFields = 'wa';
        queryParams.customQueriesSecondary = JSON.stringify([
          {
            $lookup: {
              from: 'inventory_project',
              localField: 'InventoryProjectData.InventoryProjectID',
              foreignField: '_id',
              as: 'InventoryProjectRecord',
            },
          },
          {
            $unwind: {
              path: '$InventoryProjectRecord',
              preserveNullAndEmptyArrays: true,
            },
          },
          {
            $addFields: {
              InventoryProjectRecordWarehouseLocation: {
                $ifNull: [
                  {
                    $arrayElemAt: [
                      {
                        $filter: {
                          input: '$InventoryProjectRecord.WarehouseLocations',
                          as: 'warehouse_location',
                          cond: {
                            $and: [
                              {
                                $eq: [
                                  '$$warehouse_location.LocationName',
                                  '$InventoryProjectData.OriginalWarehouseLocation',
                                ],
                              },
                            ],
                          },
                        },
                      },
                      0,
                    ],
                  },
                  null,
                ],
              },
            },
          },
        ]);
      } else if (filterOptions.searchFields == 'wl') {
        queryParams.customSearchText = queryParams.searchText;
        delete queryParams.searchText;
        queryParams.customSearchFields = ['InventoryProjectData.OriginalWarehouseLocation'];
        queryParams.searchFields = 'wl';
      } else if (filterOptions.searchFields == 'nwl') {
        queryParams.fieldsToSearch = ['LocationInWarehouse'];
        queryParams.searchFields = 'nwl';
      }
    }
    if (filterOptions.PalletID !== '') {
      queryParams.PalletID = filterOptions.PalletID;
    }
    if (filterOptions.InventoryProjectID !== '') {
      queryParams.InventoryProjectID = filterOptions.InventoryProjectID;
    }
    if (!_.isUndefined(filterOptions.inventory)) {
      queryParams.inventory = _.map(filterOptions.inventory, 'value');
    }
    if (filterOptions.listingStatuses) {
      if (_.includes(_.map(filterOptions.listingStatuses, 'value'), 'Troubleshooting')) {
        queryParams.ProductVariationsToMatch = JSON.stringify([
          {
            label: 'QualityCheckInstructions',
            value: '[TROUBLESHOOTING ROOM]',
          },
        ]);
      } else if (_.includes(_.map(filterOptions.listingStatuses, 'value'), 'Prelistings')) {
        queryParams.ProductVariationsToExclude = JSON.stringify([
          {
            label: 'QualityCheckInstructions',
            value: '[TROUBLESHOOTING ROOM]',
          },
        ]);
      }
      if (
        _.includes(_.map(filterOptions.listingStatuses, 'value'), 'ListingsPostedDirectly') &&
        _.includes(_.map(filterOptions.listingStatuses, 'value'), 'FinalizedListings')
      ) {
      } else if (_.includes(_.map(filterOptions.listingStatuses, 'value'), 'FinalizedListings')) {
        queryParams.productFinalized = 'true';
      } else if (
        _.includes(_.map(filterOptions.listingStatuses, 'value'), 'ListingsPostedDirectly')
      ) {
        queryParams.productFinalized = 'false';
      }
      queryParams.listingStatuses = _.pullAll(_.map(filterOptions.listingStatuses, 'value'), [
        'Troubleshooting',
        'FinalizedListings',
        'ListingsPostedDirectly',
      ]);
    }
    if (filterOptions.productLocationStatuses) {
      queryParams.ProductLocationStatuses = _.map(filterOptions.productLocationStatuses, 'value');
    }
    if (_.size(filterOptions.disposition)) {
      queryParams.disposition = _.map(filterOptions.disposition, 'value');
    }
    if (_.size(filterOptions.palletStatuses)) {
      queryParams.palletStatuses = _.map(filterOptions.palletStatuses, 'value');
    }
    if (filterOptions.Statuses) {
      queryParams.Statuses = _.map(filterOptions.Statuses, 'value');
    }
    if (filterOptions.zip !== '') {
      queryParams.zip = filterOptions.zip;
    }
    if (filterOptions.processingStatus) {
      queryParams.processingStatus = _.map(filterOptions.processingStatus, 'value');
    }
    console.log('quary', queryParams);
    return { queryParams };
  }

  onSelectAllProductsChange() {
    var self = this;
    if (!this.props.selectAllProducts) {
      this.props.search({ include: ['_id'], all: true }).then((response) => {
        this.props.toggleAllProductsSelection(true);
        console.log('productIDs', response);

        self.props.dispatchAction(response.data.data, ADD_SELECTED_PRODUCTS);
      });
    } else {
      this.props.toggleAllProductsSelection(false);

      this.props.dispatchAction({}, CLEAR_SELECTED_PRODUCTS);
    }
  }

  onZipCodeChange(event) {
    var updateOptions = { ...this.state.filterOptions, zip: event.target.value };
    this.setState({ filterOptions: updateOptions });
  }

  onShopifyProductIDChange(event) {
    var updateOptions = { ...this.state.filterOptions, ShopifyProductID: event.target.value };
    this.setState({ filterOptions: updateOptions });
  }

  onSearchTextChange(event) {
    var updateOptions = { ...this.state.filterOptions, searchText: event.target.value };
    this.setState({ filterOptions: updateOptions });
  }

  onFocusAreasSelect(selectedOptions) {
    var updateOptions = { ...this.state.filterOptions, focus: selectedOptions };
    this.setState({ filterOptions: updateOptions });
  }

  onSellerChange(option) {
    var updateOptions = { ...this.state.filterOptions, SellerID: option ? option.value : null };
    this.setState({ filterOptions: updateOptions });
  }

  onMarketsSelect(options) {
    var updateOptions = { ...this.state.filterOptions, Markets: options };
    this.setState({ filterOptions: updateOptions });
  }

  onCreateTimeChange(option, createTimeOptionName) {
    var updateOptions = { ...this.state.filterOptions, [createTimeOptionName]: option };
    this.setState({ filterOptions: updateOptions });
  }

  // onCreateTimeOptionChange(option) {
  //     var updateOptions = {...this.state.filterOptions, createTimeOption: option.value};
  //     this.setState({'filterOptions': updateOptions});
  // }

  onPriceChange(event, priceOptionName) {
    var updateOptions = { ...this.state.filterOptions, [priceOptionName]: event.target.value };
    this.setState({ filterOptions: updateOptions });
  }

  // onPriceOptionChange(option) {
  //     var updateOptions = {...this.state.filterOptions, priceOption: option.value};
  //     this.setState({'filterOptions': updateOptions});
  // }

  onAgeRangeChange(option) {
    var ageGroupMap = option ? [option.value] : [];
    var updateOptions = {
      ...this.state.filterOptions,
      ageGroup: option ? option.value : null,
      focus: filterFocusAreaSelectedOptions(
        this.props.focusAreas.data,
        ageGroupMap,
        this.state.filterOptions.focus
      ),
    };
    this.setState({
      filterOptions: updateOptions,
      focusAreasOptionsList:
        this.state.filterOptions.ageGroup == 'all'
          ? this.state.filterOptions.focus
          : filterFocusAreaOptions(this.props.focusAreas.data, ageGroupMap),
    });
  }

  _handleKeyPress(e) {
    if (e.key === 'Enter') {
      this.props.search();
    }
  }

  render() {
    var self = this;

    return (
      <div className="product-search-block">
        <Row className="show-grid">
          <Col md={2} sm={2} xs={3} className="top10">
            <Button className="btn btn-primary" onClick={this.onSelectAllProductsChange.bind(this)}>
              {this.props.selectAllProducts ? 'Clear selection' : 'Select all'}
            </Button>
          </Col>
          <Col md={1} sm={2} xs={3} className="top10">
            <Select
              tabIndex="0"
              // disabled={  _.size(_.get(this.state.filterOptions,'recordIDs',[])) >0}
              //  onBlur={ collapse }
              //optionRenderer={renderOption}
              //valueRenderer={renderValue}
              placeholder="Per Page"
              clearable={false}
              options={_.reject(config.perPageSelectOptions, (item) => {
                return _.includes(['all', '250'], item.value);
              })}
              onChange={this.onChangePerPageNumber.bind(this)}
              value={self.state.filterOptions.perPage}
            />
          </Col>
        </Row>

        <Row>
          {!this.state.filterOptions.PalletID && (
            <Col xs={8} md={3} sm={3} className=" top10  ">
              <Select
                tabIndex="0"
                placeholder="Listing status"
                clearable={false}
                multi
                options={listingStatusOptions}
                onChange={(selectedOptions) => {
                  if (
                    _.includes(_.map(selectedOptions, 'value'), 'ListingsPostedDirectly') &&
                    _.includes(_.map(selectedOptions, 'value'), 'FinalizedListings')
                  ) {
                    if (_.last(selectedOptions).value == 'ListingsPostedDirectly') {
                      selectedOptions = _.pullAllBy(
                        selectedOptions,
                        [
                          { value: 'PrePrelistings' },
                          { value: 'Prelistings' },
                          { value: 'FinalizedListings' },
                        ],
                        (item) => {
                          return item.value;
                        }
                      );
                    } else if (_.last(selectedOptions).value == 'FinalizedListings') {
                      selectedOptions = _.pullAllBy(
                        selectedOptions,
                        [
                          { value: 'PrePrelistings' },
                          { value: 'Prelistings' },
                          { value: 'ListingsPostedDirectly' },
                        ],
                        (item) => {
                          return item.value;
                        }
                      );
                    }
                  }

                  this.setState({
                    filterOptions: {
                      ...this.state.filterOptions,
                      listingStatuses: selectedOptions,
                    },
                  });
                }}
                value={self.state.filterOptions.listingStatuses}
              />
            </Col>
          )}
          <Col xs={8} md={3} sm={3} className=" top10  ">
            <Select
              tabIndex="0"
              placeholder="Status"
              clearable={false}
              multi
              options={statusOptions}
              onChange={(selectedOptions) => {
                this.setState({
                  filterOptions: { ...this.state.filterOptions, Statuses: selectedOptions },
                });
              }}
              value={self.state.filterOptions.Statuses}
            />
          </Col>

          <Col xs={8} md={3} sm={3} className=" top10  ">
            <Select
              tabIndex="0"
              clearable={true}
              placeholder="Deleted"
              options={[
                { value: 'true', label: 'Only deleted' },
                { value: 'all', label: 'Include' },
              ]}
              onChange={(option) => {
                console.log('option', option);
                this.setState({
                  filterOptions: {
                    ...this.state.filterOptions,
                    Deleted: option ? option.value : null,
                  },
                });
              }}
              value={self.state.filterOptions.Deleted}
            />
          </Col>
          <Col xs={8} md={3} sm={3} className=" top10  ">
            <FormControl
              type="text"
              defaultValue={this.state.filterOptions.text}
              onKeyPress={this._handleKeyPress.bind(this)}
              onChange={(event) => {
                this.setState({
                  filterOptions: { ...this.state.filterOptions, text: event.target.value },
                });
              }}
              placeholder="Title Search"
            />
          </Col>
        </Row>
        <Row>
          <Col xs={8} md={3} sm={3} className="top10  ">
            <Select
              tabIndex="0"
              //  onBlur={ collapse }
              //optionRenderer={renderOption}
              //valueRenderer={renderValue}
              placeholder="Age group"
              clearable={true}
              options={getAllowedAgeGroups()}
              onChange={this.onAgeRangeChange.bind(this)}
              value={self.state.filterOptions.ageGroup}
            />
          </Col>
          <Col xs={8} md={3} sm={3} className="top10  ">
            <Select
              placeholder="Inventory Ownership"
              clearable={false}
              multi
              options={config.inventoryOwnershipMap}
              onChange={(selectedOptions) => {
                console.log('selectedOptions', selectedOptions);
                this.setState({
                  filterOptions: { ...this.state.filterOptions, inventory: selectedOptions },
                });
              }}
              value={self.state.filterOptions.inventory}
            />
          </Col>

          <Col xs={8} md={3} sm={3} className="  top10  ">
            {_.isUndefined(this.state.filterOptions.InventoryProjectID) ? (
              <FormControl
                type="text"
                defaultValue={this.state.filterOptions.zip}
                onKeyPress={this._handleKeyPress.bind(this)}
                onChange={this.onZipCodeChange.bind(this)}
                ref="searchZipCode"
                placeholder="Zip Code"
              />
            ) : (
              <Select
                tabIndex="0"
                clearable={true}
                placeholder="Field to search"
                options={[
                  { value: 'wl', label: 'Warehouse location' },
                  { value: 'nwl', label: 'New warehouse location' },
                  { value: 'wa', label: 'Warehouse area' },
                ]}
                onChange={(option) => {
                  this.setState({
                    filterOptions: {
                      ...this.state.filterOptions,
                      searchFields: option ? option.value : null,
                    },
                  });
                }}
                value={this.state.filterOptions.searchFields}
              />
            )}
          </Col>
          <Col xs={8} md={3} sm={3} className=" top10  ">
            <FormControl
              type="text"
              defaultValue={this.state.filterOptions.searchText}
              onKeyPress={(e) => {
                if (e.key === 'Enter') {
                  this.props.search();
                }
              }}
              onChange={this.onSearchTextChange.bind(this)}
              ref="searchText"
              placeholder="Search"
            />
          </Col>
        </Row>
        <Row>
          {!this.state.filterOptions.PalletID && (
            <Col xs={8} md={3} sm={3} className=" top10  ">
              <FormControl
                type="text"
                defaultValue={this.state.filterOptions.ShopifyProductID}
                onKeyPress={this._handleKeyPress.bind(this)}
                onChange={this.onShopifyProductIDChange.bind(this)}
                ref="searchShopifyProductID"
                placeholder="Shopify Product ID"
              />
            </Col>
          )}
          <Col xs={8} md={3} sm={3} className=" top10  ">
            <Select
              tabIndex="0"
              multi
              clearable={false}
              placeholder="Location"
              options={_.map(
                _.reject(config.warehouseData, (item) => {
                  return item.FulfillmentCenter;
                }),
                (item) => {
                  return { value: item.MarketName, label: item.MarketName };
                }
              )}
              onChange={this.onMarketsSelect.bind(this)}
              value={self.state.filterOptions.Markets}
            />
          </Col>
          <Col xs={8} md={6} sm={6} className="top10  ">
            <Col xs={6} className="pleft0   ">
              <FormControl
                type="text"
                defaultValue={this.state.filterOptions.fromQuantity}
                onKeyPress={this._handleKeyPress.bind(this)}
                onChange={(e) => {
                  this.setState({
                    filterOptions: {
                      ...this.state.filterOptions,
                      ['fromQuantity']: e.target.value,
                    },
                  });
                }}
                placeholder="Min. Qty"
              />
            </Col>
            <Col xs={6} className="pright0  ">
              <FormControl
                type="text"
                defaultValue={this.state.filterOptions.toQuantity}
                onKeyPress={this._handleKeyPress.bind(this)}
                onChange={(e) => {
                  this.setState({
                    filterOptions: { ...this.state.filterOptions, ['toQuantity']: e.target.value },
                  });
                }}
                placeholder="Max. Qty"
              />
            </Col>
          </Col>
        </Row>
        <Row>
          <Col xs={8} md={6} sm={6} className="top10  ">
            <Col xs={6} className="pleft0   ">
              <Datetime
                dateFormat={'MM-DD-YYYY'}
                timeFormat={'HH:mm'}
                onChange={(value) => this.onCreateTimeChange(value, 'fromCreateTimeDisplay')}
                value={this.state.filterOptions.fromCreateTimeDisplay}
                inputProps={{ placeholder: 'From' }}
              />
            </Col>
            <Col xs={6} className="pright0 ">
              <Datetime
                dateFormat={'MM-DD-YYYY'}
                timeFormat={'HH:mm'}
                onChange={(value) => this.onCreateTimeChange(value, 'toCreateTimeDisplay')}
                value={this.state.filterOptions.toCreateTimeDisplay}
                inputProps={{ placeholder: 'To' }}
              />
            </Col>
          </Col>
          <Col xs={8} md={6} sm={6} className="top10  ">
            <Col xs={6} className="pleft0   ">
              <FormControl
                type="text"
                defaultValue={this.state.filterOptions.minPrice}
                onKeyPress={this._handleKeyPress.bind(this)}
                onChange={(e) => this.onPriceChange(e, 'minPrice')}
                ref="searchminPrice"
                placeholder="Min. price"
              />
            </Col>
            <Col xs={6} className=" pright0  ">
              <FormControl
                type="text"
                defaultValue={this.state.filterOptions.maxPrice}
                onKeyPress={this._handleKeyPress.bind(this)}
                onChange={(e) => this.onPriceChange(e, 'maxPrice')}
                ref="searchmaxPrice"
                placeholder="Max. price"
              />
            </Col>
          </Col>
        </Row>
        <Row>
          <Col xs={8} md={3} sm={3} className=" top10  ">
            <Select
              tabIndex="0"
              //  onBlur={ collapse }
              //optionRenderer={renderOption}
              //valueRenderer={renderValue}
              placeholder="Seller"
              clearable={true}
              options={this.allSellersOptionsList}
              onChange={this.onSellerChange.bind(this)}
              //  filterOptions={filterOptions}
              value={this.state.filterOptions.SellerID}
            />
          </Col>
          <Col xs={8} md={3} sm={3} className=" top10  ">
            <Select
              tabIndex="0"
              placeholder="Created By"
              clearable={true}
              options={this.allCreatedByOptionsList}
              onChange={(option) => {
                var updateOptions = {
                  ...this.state.filterOptions,
                  CreatedBy: option ? option.value : null,
                };
                this.setState({ filterOptions: updateOptions });
              }}
              value={this.state.filterOptions.CreatedBy}
            />
          </Col>
          <Col xs={8} md={3} sm={3} className=" top10  ">
            <Select
              tabIndex="0"
              placeholder="Pallet status"
              clearable={false}
              multi
              options={palletStatusOptions}
              onChange={(selectedOptions) => {
                this.setState({
                  filterOptions: {
                    ...this.state.filterOptions,
                    palletStatuses: selectedOptions,
                  },
                });
              }}
              value={self.state.filterOptions.palletStatuses}
            />
          </Col>
          <Col xs={8} md={3} sm={3} className=" top10  ">
            <Select
              tabIndex="0"
              placeholder="Disposition"
              clearable={false}
              multi
              options={config.dispositionOptions}
              onChange={(selectedOptions) => {
                this.setState({
                  filterOptions: {
                    ...this.state.filterOptions,
                    disposition: selectedOptions,
                  },
                });
              }}
              value={self.state.filterOptions.disposition}
            />
          </Col>
        </Row>
        <Row>
          <Col xs={8} md={6} sm={6} className="top10  ">
            <Col xs={6} className="pleft0   ">
              <Datetime
                dateFormat={'MM-DD-YYYY'}
                timeFormat={false}
                onChange={(value) => {
                  this.setState({
                    filterOptions: { ...this.state.filterOptions, ['fromSoldTimeDisplay']: value },
                  });
                }}
                value={this.state.filterOptions.fromSoldTimeDisplay}
                inputProps={{ placeholder: 'From Sold Time' }}
              />
            </Col>
            <Col xs={6} className="pright0  ">
              <Datetime
                dateFormat={'MM-DD-YYYY'}
                timeFormat={false}
                onChange={(value) => {
                  var isSameDate = moment(this.state.filterOptions['toSoldTimeDisplay']).isSame(
                    value,
                    'day'
                  );

                  this.setState({
                    filterOptions: { ...this.state.filterOptions, ['toSoldTimeDisplay']: value },
                  });
                }}
                value={this.state.filterOptions.toSoldTimeDisplay}
                inputProps={{ placeholder: 'To Sold Time' }}
              />
            </Col>
          </Col>
          <Col md={3} xs={6} className="  top10  ">
            <Select
              tabIndex="0"
              placeholder="Found"
              clearable={false}
              multi
              options={productLocationStatusOptions}
              onChange={(selectedOptions) => {
                this.setState({
                  filterOptions: {
                    ...this.state.filterOptions,
                    productLocationStatuses: selectedOptions,
                  },
                });
              }}
              value={self.state.filterOptions.productLocationStatuses}
            />
          </Col>
             <Col xs={8} md={3} sm={3} className="top10">
              <Select
                tabIndex="0"
                placeholder="Processing Status"
                clearable={false}
                multi
                options={productStatusLabels}
                onChange={(selectedOptions) => {
                  this.setState({
                    filterOptions: {
                      ...this.state.filterOptions,
                      processingStatus: selectedOptions,
                    },
                  });
                }}
                value={self.state.filterOptions.processingStatus}
              />
            </Col>
          <Col md={3} xs={6} className="pull-right top10">
            <button
              className="pull-right btn btn-primary"
              disabled={this.props.pending}
              onClick={(event) => self.props.search({ page: 1 })}
              type="button"
            >
              Search
            </button>
          </Col>
        </Row>
      </div>
    );
  }
}
